import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { logOut } from '../firebase/authService';

const Navbar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logOut();
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white shadow-2xl relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -mr-48 -mt-48"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -ml-32 -mb-32"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex justify-between items-center py-4">
          {/* Logo/Brand */}
          <Link
            to="/"
            className="text-3xl font-bold flex items-center space-x-2 hover:scale-105 transform transition-all duration-300"
          >
            <span className="bg-white text-blue-600 rounded-lg px-2 py-1 shadow-lg">🎯</span>
            <span className="bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent">
              JobMatch
            </span>
          </Link>

          <div className="flex items-center space-x-2">
            {!currentUser ? (
              <>
                <Link
                  to="/about"
                  className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                >
                  📖 About
                </Link>
                <Link
                  to="/company-reviews"
                  className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                >
                  ⭐ Reviews
                </Link>
                <Link
                  to="/contact"
                  className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                >
                  📧 Contact
                </Link>
                <Link
                  to="/login"
                  className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                >
                  🔐 Login
                </Link>
                <Link
                  to="/register"
                  className="bg-white text-blue-600 px-5 py-2 rounded-lg hover:bg-blue-50 font-bold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
                >
                  ✨ Register
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/dashboard"
                  className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                >
                  🏠 Dashboard
                </Link>
                <Link
                  to="/company-reviews"
                  className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                >
                  ⭐ Reviews
                </Link>
                {currentUser.role === 'jobseeker' && (
                  <Link
                    to="/profile/jobseeker"
                    className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                  >
                    👤 Profile
                  </Link>
                )}
                {currentUser.role === 'employer' && (
                  <Link
                    to="/profile/employer"
                    className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                  >
                    💼 Profile
                  </Link>
                )}
                {currentUser.role === 'admin' && (
                  <Link
                    to="/admin/dashboard"
                    className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-4 py-2 rounded-lg hover:from-yellow-500 hover:to-orange-600 font-bold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
                  >
                    👑 Admin
                  </Link>
                )}
                <Link
                  to="/settings"
                  className="px-4 py-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all font-medium transform hover:scale-105 duration-200"
                >
                  ⚙️ Settings
                </Link>
                <div className="flex items-center space-x-3 ml-2 bg-white bg-opacity-10 px-4 py-2 rounded-lg backdrop-blur-sm">
                  <div className="flex items-center space-x-2">
                    <div className="bg-white bg-opacity-20 rounded-full p-1">
                      <span className="text-lg">
                        {currentUser.role === 'admin' ? '👑' : currentUser.role === 'employer' ? '💼' : '👤'}
                      </span>
                    </div>
                    <span className="text-sm font-medium max-w-[150px] truncate">
                      {currentUser.displayName || currentUser.email}
                    </span>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="bg-gradient-to-r from-red-500 to-pink-600 px-4 py-2 rounded-lg hover:from-red-600 hover:to-pink-700 font-bold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
                  >
                    🚪 Logout
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
